import { jsxs as e, jsx as i } from "react/jsx-runtime";

import { forwardRef as t, useReducer as s, memo as l } from "react";

import r from "../InputBase/index.js";

import a from "../../utils/classNames/index.js";

const n = (e, i) => i ? i.offsetWidth : 0, o = l(t((({prefix: t, suffix: l, style: o, className: f, RootProps: m, multiline: d, ...c}, p) => {
    const [u, x] = s(n, 0), [h, v] = s(n, 0), N = u || h ? {
        ...o,
        paddingLeft: u ? 32 + u : void 0,
        paddingRight: h ? 32 + h : void 0
    } : o;
    return e("div", {
        ...m,
        className: a("relative inline-flex min-w-0 items-center", f),
        children: [ t && i("div", {
            ref: x,
            className: "left-s absolute inline-flex",
            children: t
        }), i(r, {
            ...c,
            multiline: d,
            className: "flex-auto placeholder:text-[#5D7A92]",
            style: N,
            ref: p
        }), l && i("div", {
            ref: v,
            className: "right-s absolute inline-flex",
            children: l
        }) ]
    });
})));

export { o as default };
//# sourceMappingURL=index.js.map
